import { getAgentClientAccounts } from "../../utils/apiClient";

/**
 * Fetch trading accounts for a specific IB/agent client by USER_ID.
 *
 * @param {number|string} userId - The USER_ID of the client.
 * @param {object} [options={}] - Optional options forwarded to apiClient.
 * @returns {Promise<any>} Decrypted response data (fallback to raw data/response).
 */
export const fetchAgentClientAccounts = async (userId, options = {}) => {
  const response = await getAgentClientAccounts(userId, options);

  // Prefer decryptedData from postEncryptedJson helper when available
  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  // Fallbacks
  if (response && response.data) {
    return response.data;
  }

  return response;
};

export default {
  fetchAgentClientAccounts,
};
